module.exports = __webpack_public_path__ + "img/arrow-left.a263914d.svg";